import { render, staticRenderFns } from "./WrapperTour.vue?vue&type=template&id=c5ce821e&scoped=true"
import script from "./WrapperTour.vue?vue&type=script&lang=js"
export * from "./WrapperTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ce821e",
  null
  
)

export default component.exports